module.exports = __webpack_public_path__ + "static/media/1_simplex_A_BW_square.60537de2.png";